import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bulma/css/bulma.css';
import RocketApp from './RocketApp';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <RocketApp />
);
